<template>
    <CContainer fluid class='messages-modal p-3'>
        <CRow>
            <CCol class='text-center text-sm-left'>
                <h2>Historial de mensajes</h2>
            </CCol>
            <CCol sm="12">
                <CListGroup>
                    <CListGroupItem 
                    href="#" 
                    color="dark"
                    >
                        <CRow class="d-flex message">
                             <CCol col="3" sm="2">
                                Fecha
                            </CCol>
                            <CCol col="3" sm="2">
                                <span class='d-none d-sm-block'>Usuario</span>
                                <span class='d-sm-none'>Usuario</span>
                            </CCol>
                            <CCol col="3" sm="2">
                                <span class='d-none d-sm-block'>Estado</span>
                                <span class='d-sm-none'>Estado</span>
                            </CCol>
                            <CCol col="3" sm="5">
                                <span class='d-none d-sm-block'>Mensaje</span>
                                <span class='d-sm-none'>Mensaje</span>
                            </CCol>                                                        
                        </CRow>
                    </CListGroupItem>
                    <CListGroupItem 
                        href="#" 
                        color="light"
                    >
                        <CRow class="d-flex message buyed-order-description align-items-center pb-2" v-if="buyed_order_description">
                           <CCol col="3" sm="2">
                                {{getDate(buyed_order_description.created_at)}}
                            </CCol>
                            <CCol col="3" sm="2">
                                {{buyed_order_description.user.first_name}}  {{buyed_order_description.user.last_name}}
                            </CCol>
                            <CCol col="3" sm="2">
                                {{buyed_order_description.status.name}}
                            </CCol>
                            <CCol col="3" sm="5" class=''>
                                {{buyed_order_description.description}}
                            </CCol>
                            
                            
                        </CRow>
                        <CRow class="d-flex message pt-2" v-if='delivered_order_description'>
                            <CCol col="3" sm="2">
                                {{getDate(delivered_order_description.created_at)}}
                            </CCol>
                            <CCol col="3" sm="2">
                               {{delivered_order_description.user.first_name}}  {{delivered_order_description.user.last_name}}
                            </CCol>
                            <CCol col="3" sm="2">
                                {{delivered_order_description.status.name}}
                            </CCol>
                            
                            <CCol col="3" sm="5" class=''>
                                {{delivered_order_description.description}}
                            </CCol>
                            
                        </CRow>
                        <CRow class='d-flex' v-if='!buyed_order_description && !delivered_order_description'>
                            <CCol col='12 text-center'>
                                La solicitud aún no tiene mensajes.
                            </CCol>
                        </CRow>
                        
                    </CListGroupItem>
                </CListGroup>
            </CCol>
            <br>
            <CCol sm='12 pt-2'>
                <CRow class='d-flex justify-content-sm-end'>
                    <CCol class='col-12 col-sm-auto'>
                        <CButton color='success' @click="closeModal">
                            Volver
                        </CButton>
                    </CCol>              
                </CRow>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
export default {
    props: {
        order_id: {
            type: Number,
            required: true
        },
        order: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            delivered_order_description: null,
            buyed_order_description: null
        }
    },
    created(){
        if(this.order.delivered_order_description && typeof this.order.delivered_order_description === 'object'){
            this.$api.delivered_order_descriptions.index(this.order.delivered_order_description.id)
            .then(res => {
                this.delivered_order_description = res.data;
            })
            .catch(error => {
                console.log(error)
            })
        }

        if(this.order.buyed_order_description && typeof this.order.buyed_order_description === 'object'){
            this.$api.buyed_order_descriptions.index(this.order.buyed_order_description.id)
            .then(res => {
                this.buyed_order_description = res.data;
            })
            .catch(error => {
                console.log(error)
            })
        }
    },
    methods: {
        closeModal(){
            this.$root.$emit('close-modal')
        },
        getDate(unformattedDate){
            let formattedDate = new Date(unformattedDate);
            return  formattedDate.getDate() + '/' + (formattedDate.getMonth() + 1) + '/' + formattedDate.getFullYear()
        }
    }
}
</script>

<style lang='scss' scoped>
.messages-modal{
    max-height: calc(100vh - 2rem);
    overflow-y: scroll;
    background-color: white;
    border-radius: 4px;
    @media screen and (min-width: 768px){
        overflow-y: auto;
    }
    .buyed-order-description{
        border-bottom: solid 1px rgba(0, 0, 21, 0.125);
    }
    .message{
        cursor:initial;
        align-items: center;
        
    }
}
</style>